"use strict";function fetch$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.fetch$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="runtime.message.fetch";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.6.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.6.0"},_a)),exports.fetch$=fetch$,exports.default=fetch$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/runtime/message/fetch.js
// module id = 1086
// module chunks = 106